import { ActionBarTabProps as UIActionBarTabProps } from '@shortlyster/ui-kit/dist/components/layout/ActionBar/ActionBarTab';
import { ActionBarTab as UIActionBarTab } from '@shortlyster/ui-kit';
import Link, { LinkProps } from './Link';

export type ActionBarTabProps = UIActionBarTabProps & LinkProps;

export default function ActionBarTab(props: ActionBarTabProps) {
  return <UIActionBarTab link={Link} {...props} />;
}
